import {BASE_URL} from "../config";
import axios from "axios";
import {globals} from "../helpers/globals";

function createAxiosRequest({url, method = "get", data}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user ? user.token : null;
  // const token = globals.token || '';
  const headers = {authorization: `Bearer ${token}`};
  return {url: `${BASE_URL}/${url}`, method, data, headers};
}

async function errorRequest(request) {
  // const user = JSON.parse(localStorage.getItem('user'));
  // const token = user? user.token:null;
  // const headers = {'authorization': `Bearer ${token}`}
  // const axiosRequest = {
  //     url:`${BASE_URL}/errorroutes`,
  //         method:"post",
  //         data: request,
  //         headers
  // };
  // console.log('axios', axiosRequest);
  // try{
  //     const response = await axios(axiosRequest);
  //     return response;
  // }catch(err){
  //     console.error('ERROR errorREQUEST', {axiosRequest, err});
  //     const status = err.response && err.response.status
  //     return {error: "errorRequest failed,", err, status};
  // };
}

async function simpleRequest({url, method = "get", data}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user ? user.token : null;
  const headers = {authorization: `Bearer ${token}`};
  const axiosRequest = {
    url: `${BASE_URL}/${url}`,
    method,
    data,
    headers
  };
  try {
    const response = await axios(axiosRequest);
    // console.log({axiosRequest, response})
    return response;
  } catch (err) {
    const result = await errorRequest({axiosRequest, err});
    console.error("ERROR IN AXIOS REQUEST", {axiosRequest, err});
    const errorMessage = err.response && err.response.data;
    const status = err.response && err.response.status;
    return {...err, errorMessage, status, result};
  }
}
async function simpleRequestCopy({url, method = "get", data}) {
  const token = globals.token || "";
  const headers = {authorization: `Bearer ${token}`};
  const axiosRequest = {
    url: `${BASE_URL}/${url}`,
    method,
    data,
    headers
  };
  // console.log({axiosRequest});
  try {
    const response = await axios(axiosRequest);
    // console.log(response)
    // console.log('Success', method, url, {response, axiosRequest});
    return response;
  } catch (err) {
    // console.log(err)
    console.log("Error", method, url, err && err.response);
    const errorMessage = err.response && err.response.data;
    const status = err.response && err.response.status;
    return {...err, errorMessage, status};
  }
}
async function advancedRequest({url, headers = {}, method = "GET", data = {}}) {
  // console.log('inside advancedRequest', {url, headers, method, data});
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user ? user.token : null;
  const axiosRequest = {
    url: `${BASE_URL}/${url}`,
    method,
    data,
    headers: {...headers, authorization: `Bearer ${token}`}
  };
  try {
    const response = await axios(axiosRequest);
    // console.log('Success', url, response.status, response.data, response.error);
    return response;
  } catch (err) {
    const res = err.response;
    const message = `Error: Status ${res && res.status}, ${res && res.statusText} (${res && res.data})`;
    return {...err, message};
  }
}

async function getErrors(type) {
  const url = `${BASE_URL}/errors/${type}`;
  const response = await axios.get(url);
  return response;
}
export {simpleRequest, simpleRequestCopy, getErrors, advancedRequest, createAxiosRequest};
